
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand/[...url]",
      function () {
        return require("private-next-pages/brand/[...url].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand/[...url]"])
      });
    }
  